<template>
  <!--柱状图-->
  <div :id="id" :style="`height: ${height}px`" class="chart" />
</template>

<script>
import  elementResizeDetectorMaker from 'element-resize-detector';
// import {debounce} from "@/utils";
export default {
  props: {
    id: {
      type: [String, Number],
      default: 'chart',
    },
    // 标题
    title: {
      type: String,
      default: '',
    },
    left: {
      type: String,
      default: '',
    },
    percent: { // 百分号
      type: String,
      default: '',
    },
    // 图表数据
    data: {
      type: Object,
      default: () => {},
    },
    // 图表高度
    height: {
      type: Number,
      default: 440,
    },
    // 图表区域左侧边距
    gridLeft: {
      type: Number,
      default: 20,
    },
    interval:{
      type: Number,
      default: 0,
    },
    rotate:{
      type: Number,
      default: 0,
    },
    // 图表区域右侧边距
    gridRight: {
      type: Number,
      default: 20,
    },
    // 图表类型
    type: {
      type: String,
      default: 'bar',
    },
    // 是否显示图例
    legendShow: {
      type: Boolean,
      default: true,
    },
    // 柱形颜色
    barColor: {
      type: Array,
      default: () => ['#006df0', '#0acf97', '#fc7f03', '#d149fe', '#fe6d65', '#fcd02d', '#9ad864'],
    },
    instance: [Object, String],
  },
  data() {
    return {
      // 图表配置
      optionEcharts: {
        // 标题
        title: {
          text: this.title,
          left: this.left
        },
        tooltip: {
          trigger: 'axis',
          confine: true, // 限制在图表区域内
        },
        // 图例
        legend: {
          show: this.legendShow,
          itemWidth: 6,
          itemHeight: 6,
          textStyle: {
            // color: '#ffffff'
          },
          right: '0%',
        },
        // 数据集
        dataset: {
          source: this.data.source,
        },
        // 图表区域大小
        grid: {
          left: this.gridLeft,
          right: this.gridRight,
          bottom: '0',
          containLabel: true, // 包含标签
        },
        // X轴
        xAxis: {
          type: 'category',
          axisLabel: {
            interval: this.interval,
            rotate: this.rotate
          },
        },
        // y轴
        yAxis: {
          type: 'value',
          name: '',
          offset: 0, // 偏移
          position: 'left', // 位置
          axisLabel: {
            formatter: '{value}' + this.percent, // 61A0A8
          },
          nameTextStyle: {
            // color: '#fff'
          },
          // 刻度线
          axisTick: {
            show: false,
          },
          // 坐标轴线
          axisLine: {},
          // x轴网格线颜色
          splitLine: {},
        },
        series: [],
      },
    };
  },
  watch: {
    // 监听数据集
    data: {
      deep: true,
      handler(val) {
        // console.log(val)
        this.optionEcharts.dataset.source = val.source;
        this.initChart();
      },
    },
  },
  mounted() {
    this.charData(); // 处理数据
    this.initChart(); // 初始化echarts实例
  },
  methods: {
    charData() {
      // 提示框
      this.optionEcharts.tooltip = this.data.tooltip || this.optionEcharts.tooltip;
      // y轴数据
      this.optionEcharts.yAxis = this.data.yAxis || this.optionEcharts.yAxis;
      // 系列
      this.data.series.forEach((item, index) => {
        this.optionEcharts.series.push({
          type: item.type, // 图表类型
          barWidth: item.barWidth, // 柱宽度
          markLine: item.markLine, // 平均线
          yAxisIndex: item.yAxisIndex, // 有多条y轴时，设置y轴索引
          color: this.barColor[index], // 柱形颜色
        });
      });
    },
    initChart() {
      const echarts = require('echarts');
      const chartList = document.getElementById(this.id);
      elementResizeDetectorMaker().listenTo(chartList, () => {
        const that = this;
        that.$nextTick(() => {
          chart.resize();
        });
      });
      // 初始化echarts实例
      const chart = echarts.init(chartList);
      this.$nextTick(() => {
        // 图表配置
        chart.setOption(this.optionEcharts);
        // 图表的自适应
        window.addEventListener('resize', () => {
          chart.resize();
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  ::v-deep .chart{
    min-width: 250px;
    //width: 100%;
  }
  ::v-deep .chart div canvas{
    min-width: 250px;
    width: 100%;
  }
</style>
